import { FONT_FAMILY } from "@/constants";
import { Theme } from "@mui/material";

const TableRow = (theme: Theme) => ({
  MuiTableRow: {
    styleOverrides: {
      // Name of the slot
      root: {
        // Some CSS
        fontFamily: FONT_FAMILY,
      },
    },
  },
});

export default TableRow;
